import React, { useCallback } from "react";

import cx from "classnames";

import ebook2x from "../images/1on1-ebook-3d.png";
import john1x from "../images/john.png";
import john2x from "../images/john@2x.png";
import justin1x from "../images/justin.png";
import justin2x from "../images/justin@2x.png";
import lea1x from "../images/lea.png";
import lea2x from "../images/lea@2x.png";
import mike1x from "../images/mike.png";
import mike2x from "../images/mike@2x.png";
import mychelle1x from "../images/mychelle.png";
import mychelle2x from "../images/mychelle@2x.png";
import sabrina1x from "../images/sabrina.png";
import sabrina2x from "../images/sabrina@2x.png";
import sean1x from "../images/sean.png";
import sean2x from "../images/sean@2x.png";
import tyler1x from "../images/tyler.png";
import CompanyLogos from "./CompanyLogos";
import type { PaneProps } from "./types";

import styles from "../css/Auth.module.css";

function Testimonial() {
	const { topic_tag: topicTag } = window.INITIAL_STATE;

	const getTestimonial = useCallback(() => {
		if (topicTag === "engineering") {
			return (
				<>
					<img src={tyler1x} />
					<div>
						“<span className={styles.emphasis}>Fellow was a lot like when we adopted Slack</span> at Vidyard. [...]{" "}
						<br /> It very slowly got its hooks into our daily processes so much that it became almost invisible.
						That&apos;s what Fellow became.
						<span className={styles.emphasis}>It just became the place. That&apos;s where the agenda is.</span>{" "}
						That&apos;s where the notes are taken. Every meeting has it.”
					</div>
				</>
			);
		} else if (topicTag === "feedback") {
			return (
				<>
					<img src={justin1x} srcSet={`${justin1x} 1x, ${justin2x} 2x`} />
					<div>
						“
						<span className={styles.emphasis}>
							One of the best additions to our feedback loop has been the company-wide adoption of Fellow.
						</span>{" "}
						It provides an amazing platform for constant conversations and direct feedback between managers and direct
						reports.”
					</div>
				</>
			);
		} else if (topicTag === "oneonones") {
			return (
				<>
					<img src={sabrina1x} srcSet={`${sabrina1x} 1x, ${sabrina2x} 2x`} />
					<div>
						“{/* eslint-disable-next-line max-len */}
						<span className={styles.emphasis}>
							Fellow helps my team have more collaborative one-on-one meetings.
						</span>{" "}
						My teammates love capturing their own agenda items, and getting prompted is super handy when jumping from
						one meeting to the next.”
					</div>
				</>
			);
		} else if (topicTag === "actionitems") {
			return (
				<>
					<img src={john1x} srcSet={`${john1x} 1x, ${john2x} 2x`} />
					<div>
						{/* eslint-disable max-len */}
						“Fellow helps us stay organized and follow up on the action items that inevitably come out of every meeting.{" "}
						<span className={styles.emphasis}>It’s been a game-changer for our team.</span>”
					</div>
				</>
			);
		} else if (topicTag === "guidelines") {
			return (
				<>
					<img src={lea1x} srcSet={`${lea1x} 1x, ${lea2x} 2x`} />
					<div>
						{/* eslint-disable max-len */}
						“Fellow with Meeting Guidelines provides a frictionless, fun way for employees to be more mindful in their
						approach to meetings and ensures they’re consciously building in meeting best practices. Fellow also gives
						them control over their time and the permission to push back on meetings that lack an agenda.{" "}
					</div>
				</>
			);
		} else if (topicTag === "ai") {
			return (
				<>
					<img src={mike1x} srcSet={`${mike1x} 1x, ${mike2x} 2x`} />
					<div>
						{/* eslint-disable max-len */}
						“I’m generally an AI skeptic, but we used the Fellow AI meeting assistant and it was really good.{" "}
						<span className={styles.emphasis}>The AI summary is truly sublime.</span>”
					</div>
				</>
			);
		} else if (topicTag === "oneononeebook") {
			return (
				<>
					<div>
						Thank you for downloading our eBook! <br /> It should arrive in your inbox shortly.
					</div>
					<img src={ebook2x} style={{ margin: "1em 0" }} />
					<div>
						{/* eslint-disable max-len */}
						Implementing what you learn is the next and most important step.{" "}
						<span className={styles.emphasis}>
							Fellow can help with 500+ meeting templates that integrate with your existing systems and workflows.
						</span>
					</div>
				</>
			);
		} else {
			return (
				<>
					<img src={mychelle1x} srcSet={`${mychelle1x} 1x, ${mychelle2x} 2x`} />
					<div>
						“Fellow solves three key problems around running meetings. First, creating the agenda. Then, with the
						ability to take notes, meeting management becomes much simpler. And finally, tracking the action items that
						come out of every meeting.{" "}
						<span className={styles.emphasis}>
							Having everything in Fellow means we can track it and follow up on it.”
						</span>
					</div>
				</>
			);
		}
	}, [topicTag]);

	return getTestimonial();
}

function TestimonialFooter() {
	const { topic_tag: topicTag } = window.INITIAL_STATE;

	if (topicTag === "oneononeebook") {
		return (
			<div className={cx(styles.shiftedDown, styles.largeMonitorOnly)}>
				<h3>Try Fellow for free with your team 👉</h3>
			</div>
		);
	}

	return <CompanyLogos />;
}

export default function TestimonialPane({ bgStyle = "dot" }: PaneProps) {
	const { topic_tag: topicTag } = window.INITIAL_STATE;

	if (!topicTag) {
		return (
			<div className={cx(styles.authPane)}>
				<div className={cx(styles.testimonialPane, styles[bgStyle])}>
					<div className={styles.shiftedUp} />
					<div className={cx(styles.shiftedCenter, styles.testimonial)}>
						<img src={sean1x} srcSet={`${sean1x} 1x, ${sean2x} 2x`} />
					</div>
					<TestimonialFooter />
				</div>
			</div>
		);
	} else {
		return (
			<div className={styles.authPane}>
				<div className={styles.testimonialPane}>
					<div className={styles.shiftedUp} />
					<div className={cx(styles.shiftedCenter, styles.testimonial)}>
						<Testimonial />
					</div>
					<TestimonialFooter />
				</div>
			</div>
		);
	}
}
